export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
    label: 'label.no',
    thClass: 'w-50px',
  },
  {
    key: 'operator',
    // sortable: true,
    sortField: 'operator',
    label: 'field.operator',
    stickyColumn: true,
    variant: 'light',
    thClass: 'text-left',
    tdClass: 'text-left',
  },
  {
    key: 'totalAccepted',
    label: 'field.totalAccepted',
  },
  {
    key: 'totalResolved',
    label: 'field.resolvedCount',
  },
  {
    key: 'reworkDetail',
    label: 'field.reworkDetail',
  },
  {
    key: 'workingDay',
    label: 'field.workingDay',
  },
  {
    key: 'avgTimeToResolve',
    label: 'field.avgResolveTime',
  },
  {
    key: 'cumulativeTimeToResolve',
    label: 'field.totalResolveTime',
  },
  {
    key: 'restTime',
    label: 'field.restTime',
  },
]
